import { render, staticRenderFns } from "./TgNote.vue?vue&type=template&id=930cfd3a&"
import script from "./TgNote.vue?vue&type=script&lang=js&"
export * from "./TgNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports